module.exports = __webpack_public_path__ + "img/esport-1.468649af.svg";